import { CircularProgress, Box } from '@material-ui/core';
import React, { useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { useUser } from '../../context/UserContext';
import { refreshCustomerSession } from '../../services/customerService';

const AuthOrApp = () => {
	const { user } = useUser();
	const history = useHistory();

	const tryLogin = useCallback(async () => {
		const [err] = await refreshCustomerSession();
		if (err) {
			history.push('/login');
			return;
		}
		history.push('/home/usuarios');
	}, [history]);

	useEffect(() => {
		if (user) {
			tryLogin();
		} else {
			history.push('/login');
		}
	}, [user, tryLogin, history]);

	return (
		<Box display="flex" justifyContent="center" alignItems="center" width="100vw" height="100vh">
			<CircularProgress color="primary" />
		</Box>
	);
};

export default AuthOrApp;
